import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Eyebrow} from '@/components/ui/eyebrow'
import {Button} from '@/components/ui/button'
import {API_ERROR_MESSAGE} from '@salesforce/retail-react-app/app/constants'
import {useIntl} from 'react-intl'
import {useToast} from '@/hooks/useToast'
import {useShopperBasketsMutationHelper} from '@salesforce/commerce-sdk-react'
import {useCurrentBasket} from '@/hooks/basket/useCurrentBasket'
import CloseBlack from 'hec/assets/icons/minicart-close'
import LoadingSpinner from '~/app/components/loading-spinner'

import {cn} from '@/lib/utils'

const AddRemovedProduct = ({product, setRemovedProducts}) => {
    const [hide, setHide] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const {formatMessage} = useIntl()
    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const {data: currentBasketData, refetchBaskets} = useCurrentBasket()
    const {productName} = product

    const showToast = useToast()
    const showError = () => {
        showToast({
            title: formatMessage(API_ERROR_MESSAGE),
            status: 'error'
        })
    }

    const handleAddToCart = async () => {
        setIsLoading(true)
        try {
            const productItems = [
                {
                    productId: product.productId,
                    price: product.price,
                    quantity: product.quantity
                }
            ]

            await addItemToNewOrExistingBasket(productItems, currentBasketData).then(async () => {
                await refetchBaskets()
            })
            setRemovedProducts([])
        } catch (error) {
            console.log('error', error)
            showError(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div
            className={cn('flex flex-col relative pt-[3.5625rem] pb-[4.125rem]', hide && 'hidden')}
        >
            <button onClick={() => setHide(true)} className="absolute top-[1.375rem] right-0">
                <CloseBlack />
            </button>
            <div className="px-5 mb-5 w-full">
                <Eyebrow
                    size="large"
                    className="text-emphasis"
                    style={{textTransform: 'none'}}
                    data-testid="addRemovedProduct-Eyebrow"
                    type="text"
                >
                    You just removed {productName} from your cart
                </Eyebrow>
            </div>
            <Button
                ctaType="button"
                variant="primary"
                onClick={handleAddToCart}
                disabled={isLoading}
                className="w-auto mx-auto min-w-[14.5rem]"
                data-testid="addRemovedProduct-Button"
            >
                {isLoading ? (
                    <LoadingSpinner data-testid={'addRemovedProduct-LoadingSpinner'} />
                ) : (
                    'Add Item Back'
                )}
            </Button>
        </div>
    )
}

AddRemovedProduct.propTypes = {
    product: PropTypes.object.isRequired,
    setRemovedProducts: PropTypes.func.isRequired
}

export default AddRemovedProduct
